import { useEffect } from 'react'
import { reaction } from 'mobx'
import { observer } from 'mobx-react-lite'
import { checkToken, makeCustomersInternational } from '../services/Network'
import { isCountryVietnam, getNativeName } from './GlobalHelpers'
import { assignCustomer, clearCartStorage } from './utils/Customer'
import { resetReferralStore } from './EnrollHelper'
import { ACL, AllowList, Menu, appConfig } from './config'
import { checkCountry } from '../CheckCountry'

import { loge, logn } from '@Utils/PikaLog'
import { StorageExtend } from '@Utils/StorageManager'
import { isSomething, isNothing, someOf } from '@Utils/Utils'
import { getParameterByName, getQueryString, hasQueryString } from '@Configs/ConfigsHeader'
import { Country } from '@Configs/Country'

import { store, checkOutStore, staticFooter } from '@Stores/MainStore'
import StoreAuth from '@Stores/User/StoreAuth'
import StoreMenu from '@Stores/StoreMenu'
import SessionAuth from '@Stores/User/SessionAuth'
import StoreProfile from '@Stores/StoreProfile'

import get from 'lodash/get'
import axios from 'axios'
import Raven from '@Raven'
import { updateBalance } from '@Services/APIs/APIBalance'
import { lowerCase } from '@Utils/String'
import { storeAPI } from '@Stores/StoreAPI'
import { storeNotification } from '@Stores/StoreNotification'
import StoreCountry from '@Stores/StoreCountry'
import { storeElement } from '@Stores/StoreElement'

const { Code2 } = Country
const optionsReaction = { fireImmediately: true }

export const SetLastVisit = page => {
    if (hasQueryString('through')) {
        let splitQueryString = window.location.search.replace('?', '')
        splitQueryString = splitQueryString.split('&')
        let newQueryString = '?'
        splitQueryString.map(v => {
            if (v !== 'through') {
                if (newQueryString !== '?') {
                    newQueryString += `&${v}`
                } else {
                    newQueryString += v
                }
            }
        })
        let url = window.location.href.split('?')
        localStorage.setItem('last-visited', `${url[0]}${newQueryString}`)
    } else {
        if (window.location.hash.indexOf('login') === -1 && localStorage.getItem('last-visited')) {
            localStorage.removeItem('last-visited')
        }
    }
}

const GetLastVisit = () => {
    if (localStorage.getItem('last-visited')) {
        const lastVisited = localStorage.getItem('last-visited')

        window.location.href = lastVisited
    } else {
        window.location.href = StoreAuth.pageBeforeLogin ? StoreAuth.pageBeforeLogin : '/office/#/login'
    }
}

/** Applied the authorize reactions to component.
 * The process begin after acknowledge the login type.
 */
export const useAuthorization = () => {
    /** Query string params for auto-login. */
    const { autoLogin: qsToken, isWebview: isWebview } = getQueryString()

    useEffect(() => {
        /** Watch login type to decide the login process after acknowlege.
         * Set auto-login token or restore user. */
        reaction(
            () => StoreAuth.loginType,
            (type, pType, rType) => {
                if (type && isNothing(pType)) {
                    if (StoreAuth.isAutoLogin) {
                        // start a request for required data of user
                        requestCustomer(qsToken)
                            .then(r => {
                                updateBalance()
                            })
                            .catch(e => {
                                failed(e)
                            })
                    } else {
                        requestSessionRestore()
                    }
                    // destroy this reaction
                    rType.dispose()
                }
            },
            optionsReaction
        )

        // Decide type of login
        if (isSomething(qsToken)) {
            // The query string for auto-login is exist
            StoreAuth.setLoginToAuto()
        } else {
            // No auto-login
            StoreAuth.setLoginToNormal()
        }
    }, [])

    const failed = reason => {
        console.error('Auto-login colud not be done:', reason)
        StoreAuth.setAutoLoginStatus('failed')
        StoreAuth.isInitilized = true
    }

    const requestCustomer = autoLoginToken => {
        storeAPI.MainApiStartLoad.menu = true
        return new Promise((resolve, reject) => {
            axios(`https://member-calls2.unicity.com/remoteStorage/broker/${autoLoginToken}`)
                .then(response => {
                    const data = response.data
                    if (data) {
                        const { baId, token } = data.payload
                        StoreAuth.AutoLogin(baId, token, Country.getCode3())
                            .then(response => {
                                storeAPI.MainApiStartLoad.menu = false
                                if (store.isWebview) {
                                    countryInit()
                                }
                                logn('✅ 🔐 Auto Login Successfully')
                                updateApiLoad()
                                StoreAuth.setAutoLoginStatus('success')
                                storeAPI.MainApiStartLoad.menu = false
                                resolve()
                            })
                            .catch(error => {
                                storeAPI.MainApiStartLoad.menu = false
                                reject(error)
                            })
                    } else {
                        storeAPI.MainApiStartLoad.menu = false
                        reject(JSON.stringify(response))
                    }
                })
                .catch(error => {
                    reject(JSON.stringify(error))
                })
        })
    }
}

const countryInit = () => {
    const responseCountry = checkCountry()
    responseCountry.then(response => {
        if (response) {
            if (response.success === true) {
                StoreCountry.country = response.country
                StoreCountry.init(response.data)
                document.title = `UNICITY (${response.country.shorter})`
                StorageExtend.set(lowerCase(response.country.country), 'development.memoized-country')
            } else {
                logoutWebview()
            }
        }
    })
}

const updateApiLoad = () => {
    storeAPI.MainApiStartLoad.menu = false
}

const requestSessionRestore = () => {
    SessionAuth.ShouldRestore()
        .then(() => {
            console.log('---------------------------- requestSessionRestore ----------------------------')
            storeAPI.MainApiStartLoad.menu = true
            StoreAuth.Restore(SessionAuth.Current())
                .then(response => {
                    logn('✅ 🔐 Successfully restore session:\n>')
                    if (get(response, 'forceResetPassword.isRequred', false) === true) {
                        SessionAuth.SetNeedResetPassword(true)

                        storeAPI.MainApiStartLoad.menu = false
                    } else {
                        StoreProfile.setUserMarket(get(response, 'userCountry'))
                        StoreProfile.setProfileData(get(response, 'onself.ushop.profile'))
                        StoreProfile.setCommission(get(response, 'onself.ushop.commission'))
                        StoreProfile.setLsb(get(response, 'onself.ushop.lsb'))

                        const allowed = get(response, 'onself.ushop.profile.acl.allowed')

                        StoreAuth.ACLFile = 'AclFull'

                        StoreMenu.setMenu(response.menu)
                        StoreMenu.setQuotes(response.quotes)
                        // * Update BALANCE features (CashCoupon/ARBalance)
                        updateBalance()
                    }
                })
                .catch(error => {
                    loge('❌ 🔐 Failed to restore session:', error)
                    StoreAuth.isInitilized = true
                    updateApiLoad()
                    localStorage.clear()
                    sessionStorage.clear()
                })
        })
        .catch(e => {
            if (e.message === 'no-token') {
                loge('❌ 🔐 Failed to restore session:', e)
                if (Country.path) {
                    logn('✅ 🔐 Anonymous user detected, no need to authorize.')
                    StoreAuth.ACLFile = 'AclPublic'
                    storeAPI.MainApiStartLoad.menu = true
                    Raven.getMenuPublic()
                        .then(response => {
                            StoreMenu.setMenu(response.menu)
                            StoreMenu.setQuotes(response.quotes)
                            storeNotification.setRawContent(response.popup)
                            StoreAuth.isInitilized = true
                            updateApiLoad()
                        })
                        .catch(error => {
                            console.log('error getMenuPublic:', error)
                            StoreAuth.isInitilized = true
                            updateApiLoad()
                        })
                } else {
                    logn('✅ 🔐 The authorization is no need.')
                }
            } else {
                localStorage.clear()
                sessionStorage.clear()
            }
        })
}

// --------

const recognizeCustomer = (data, href, token) => {
    localStorage.removeItem('referral')
    assignCustomer(data, href, token)
}

const getAcl = (type, status) => {
    let acl = null
    let menu = []
    Object.keys(ACL).map((v, k) => {
        if (ACL[v].api.type === type && ACL[v].api.status === status) {
            if (ACL[v].allowed === false) {
                return false
            }

            acl = ACL[v]
            acl.status = v
            acl.allowList = AllowList[ACL[v].allowed]

            if (acl.allowList === true) {
                acl.mainMenu = Menu()
            } else {
                let menu = []
                let tempMenu = Menu()

                tempMenu.map((b, i) => {
                    if (acl.allowList.sideBar.indexOf(b.key) >= 0) {
                        menu.push(b)
                    }
                })
                acl.mainMenu = menu
            }
            acl.inPageMenu = {}
            Object.keys(AllowList.inPageMenu).map((m, n) => {
                if (acl.inPageMenu[m] === undefined) {
                    acl.inPageMenu[m] = []
                }
                AllowList.inPageMenu[m].map((a, b) => {
                    if (a.allowed.indexOf(ACL[v].allowed) >= 0) {
                        acl.inPageMenu[m].push(JSON.parse(JSON.stringify(a)))
                    }
                })
            })
        }
    })

    if (acl !== null && acl !== false) {
        acl.country = appConfig.country
    }

    return acl
}

export const login = async (username, password, callback, customerToken, customerHref, history) => {
    let timeout = StoreAuth.loginRetried === true ? 0 : parseInt(getParameterByName('timeout'))
    let retryTiming = parseInt(getParameterByName('retry')) || staticFooter.retryLogin

    if (customerToken === undefined && customerHref === undefined) {
        try {
            const response = await StoreAuth.Login(username, password, timeout)
            
            storeAPI.login.isRedirecting = true
            resetReferralStore()
            localStorage.removeItem('logoutDailogShown')
            checkOutStore.dToken = null
            GetLastVisit()
            window.location.reload()
        } catch (error) {
            if (error) {
                if (error.isTimeout && StoreAuth.loginRetried === false) {
                    setTimeout(() => {
                        StoreAuth.loginRetried = true
                        login(username, password, callback, customerToken, customerHref, history)
                    }, retryTiming)
                } else {
                    callback(error)
                }
            } else {
                callback(error)
            }
        }
    }
}

export const logout = (redirect = true) => {
    storeAPI.login.isRedirecting = true

    StorageExtend.unsetFromPersonal('checkout-restore')

    StoreAuth.Logout()
    StoreMenu.Reset()

    localStorage.removeItem('dummy-user')

    if (redirect === true) {
        localStorage.removeItem('enroll_data')
        localStorage.removeItem('enroll_state')
        localStorage.removeItem('itemData')
        localStorage.removeItem('language')
        localStorage.removeItem('productData')
        localStorage.removeItem('products')
        localStorage.removeItem('footer-data')
        localStorage.removeItem('checkOutStore')
        localStorage.removeItem('storageEnrollCart')
        localStorage.removeItem('EnrollStorage')
        localStorage.removeItem('ShoppingStorage')
        localStorage.removeItem('notificationShown')
        localStorage.removeItem('isDummy')

        logoutWebview()
        store.authPass = false

        window.location.reload()
    } else {
        // store.customerData = {}
        store.authPass = false
    }
}

export const logoutWebview = () => {
    // webview logout function only for react native webview browsers
    // if token expires or failed to fetch customer data using token & href => then signout
    if (store.isWebview) {
        localStorage.removeItem('fired')
        localStorage.removeItem('loggedIn')
        // window.ReactNativeWebView.postMessage(JSON.stringify({ data: {}, targetFunc: "session-logout" }));
        // localStorage.removeItem('isWebview');
        window.ReactNativeWebView.postMessage(JSON.stringify({ data: {}, targetFunc: 'logout' }))
    }
}
